module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox@2x-094cad8c4bf551a89d41f171506b0fa6.png";